/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CreateUserHistoryInput = {
    readonly clientMutationId: string;
    readonly id: string;
    readonly item: string;
    readonly description?: string | null;
};
export type createUserHistoryMutationVariables = {
    readonly input: CreateUserHistoryInput;
};
export type createUserHistoryMutationResponse = {
    readonly createUserHistory: {
        readonly clientMutationId: string | null;
        readonly hasErrors: boolean | null;
        readonly errors: ReadonlyArray<{
            readonly id: string;
            readonly location: string | null;
        } | null> | null;
        readonly userHistory: string | null;
    } | null;
};
export type createUserHistoryMutation = {
    readonly response: createUserHistoryMutationResponse;
    readonly variables: createUserHistoryMutationVariables;
};



/*
mutation createUserHistoryMutation(
  $input: CreateUserHistoryInput!
) {
  createUserHistory(input: $input) {
    clientMutationId
    hasErrors
    errors {
      id
      location
    }
    userHistory
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateUserHistoryInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createUserHistory",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateUpdateUserHistoryPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasErrors",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "errors",
        "storageKey": null,
        "args": null,
        "concreteType": "Error",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "location",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "userHistory",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "createUserHistoryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "createUserHistoryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "createUserHistoryMutation",
    "id": null,
    "text": "mutation createUserHistoryMutation(\n  $input: CreateUserHistoryInput!\n) {\n  createUserHistory(input: $input) {\n    clientMutationId\n    hasErrors\n    errors {\n      id\n      location\n    }\n    userHistory\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'b95fbeb4b60bb6318b855b12ec38b525';
export default node;
